import { FormControl, Grid, InputLabel, MenuItem, Select } from "@mui/material";
import Field from "components/Field";
import { useId } from "react";
import { useIntl } from "react-intl";
import { SponsorTypeIds, SponsorTypeNames } from "types/common-types";

type Props = {
  fieldName: string;
  initialValue?: string;
};

export function SponsorTypeField({ fieldName, initialValue }: Props) {
  const { formatMessage: t } = useIntl();
  const labelId = useId();

  return (
    <Field
      name={fieldName}
      initialValue={initialValue ?? SponsorTypeIds.Sponsor}
    >
      {({ input }) => (
        <Grid item xs={12}>
          <FormControl fullWidth variant="standard">
            <InputLabel id={labelId}>
              {t({ id: "sponsorTypeLabel" })}
            </InputLabel>
            <Select
              labelId={labelId}
              value={input.value || SponsorTypeIds.Sponsor}
              onChange={(e) => input.onChange(e.target.value)}
            >
              <MenuItem value={SponsorTypeIds.Sponsor}>
                {t({ id: "sponsorTypeSponsor" })}
              </MenuItem>
              <MenuItem value={SponsorTypeIds.JointProvider}>
                {t({ id: "sponsorTypeJointProvider" })}
              </MenuItem>
            </Select>
          </FormControl>
        </Grid>
      )}
    </Field>
  );
}

export function sponsorTypeIdToName(id: string | undefined): string {
  if (id?.toUpperCase() === SponsorTypeIds.JointProvider.toUpperCase()) {
    return SponsorTypeNames.JointProvider;
  }
  return SponsorTypeNames.Sponsor;
}
